import { callApi } from '../services/api';

const getPromotionsAnalyze = (data) => {
  return callApi.get('/coupons/analyses', { params: data });
};

export { getPromotionsAnalyze };
